export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND_CLOUD = process.env.REACT_APP_BACKEND_CLOUD_URL;
